export const SET_TASK_PARTNERS = 'taskPartnerSearch/SET_TASK_PARTNERS';
export const CLEAR_SEARCH = 'taskPartnerSearch/CLEAR_SEARCH';
